function groupFoodMenu({meat, fish, veg}) {
    const menuGroupedByType = Object.entries({meat, fish, veg})
        .map(([_, options]) => ({
            label: options.alias,
            count: options.val,
        }))
        .filter(entry => entry.count > 0);

    return menuGroupedByType.map(
        food => '%count x %label'
            .replace(
                '%count',
                food.count,
            )
            .replace(
                '%label',
                food.label,
            ));
}

function listFoodMenu(menu) {
    return groupFoodMenu(menu).join(', ');
}

export { groupFoodMenu, listFoodMenu };
